import React from 'react';
export default (
  <svg width="34px" height="34px" viewBox="0 0 34 34">
    <g
      transform="translate(1 1)"
      stroke="#ADB5BD"
      strokeWidth={2}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5.6,28 C9.33333333,26.4 11.7333333,25.0666667 12.8,24 C14.4,22.4 9.6,22.4 9.6,14.4 C9.6,9.06666667 11.7333333,6.4 16,6.4 C20.2666667,6.4 22.4,9.06666667 22.4,14.4 C22.4,22.4 17.6,22.4 19.2,24 C20.2666667,25.0666667 22.6666667,26.4 26.4,28" />
      <circle cx={16} cy={16} r={16} />
    </g>
  </svg>
);
